import { useState } from 'react';
import { MonthTrendView } from '../components/analytics/MonthTrendView';
import { MonthView } from '../components/analytics/MonthView';
import { WeekView } from '../components/analytics/WeekView';
import { YearTrendView } from '../components/analytics/YearTrendView';

const tabs = [
  { key: 'week', label: 'Woche (KW)' },
  { key: 'month', label: 'Monat im Detail' },
  { key: 'monthTrend', label: 'Monatsverlauf' },
  { key: 'yearTrend', label: 'Jahresverlauf' },
] as const;

type TabKey = (typeof tabs)[number]['key'];

export function Analytics() {
  const [tab, setTab] = useState<TabKey>('week');

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white">Analysen</h1>

      <div className="flex flex-wrap gap-2 border-b border-slate-200 pb-3 dark:border-slate-800">
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${
              tab === t.key
                ? 'bg-brand-600 text-white'
                : 'text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'week' && <WeekView />}
      {tab === 'month' && <MonthView />}
      {tab === 'monthTrend' && <MonthTrendView />}
      {tab === 'yearTrend' && <YearTrendView />}
    </div>
  );
}
